<template>
  <base-message :message="message" :full-width="true">
    <div class="message-body"
         :class="{'is-active': active}">
      <div class="pk-logo">学习对战！</div>

      <div class="pk-body">
        <div class="school school-left">
          <img class="image" :src="$publicPath('/duck.jpg')" alt="">
          <div class="flag">北京烤鸭大学</div>
        </div>
        <div class="pk">
          <div class="pk-icon">
            <img class="fork" width="80" :src="$publicPath('/images/fork.svg')" alt="">
          </div>
          <div class="pk-icon">
            <img class="spoon" width="80" :src="$publicPath('/images/spoon.svg')" alt="">
          </div>
        </div>
        <div class="school school-right">
          <div class="flag">{{ message.data.name }}</div>
          <img class="image" :src="message.data.image" alt="">
        </div>
      </div>
    </div>
  </base-message>
</template>

<script>
// import LoadingDot from './LoadingDot'
import IClassroom from '@/components/classroom/lib/IClassroom'
import BaseMessage from '@/components/classroom/messages/BaseMessage'

export default {
  components: { BaseMessage },
  data () {
    return {
      IClassroom,
      active: false
    }
  },
  mounted () {
    setTimeout(() => {
      this.active = true
    }, 30)
    setTimeout(() => {
      IClassroom.setOpponent(this.message.data)
      IClassroom.requestNextMessage(1000)
    }, 2000)
  },
  props: ['message']
}
</script>

<style lang="stylus" scoped>
.pk-body {
  display flex
  align-items center
  justify-content space-between
  user-select none
  padding 0
  border 3px solid $dark
  border-radius 3px
  overflow hidden
}

.message-body {
  padding 0
}

.school {
  position relative
  width 50%
  height 100px
  display flex
  justify-content space-between
  align-items center
  padding 1rem
  transition all .6s
}

.pk {
  width 72px
  height 72px
  position absolute
  left 50%
  top 50%
  transform translate(-50%, -50%)
  display flex
  z-index 2

  &:before {
    width 70%
    height 70%
    content ''
    position absolute
    left 15%
    top 15%
    border-radius 50%
    background white
    opacity: 0;
    transition opacity .1s linear .6s
  }
}

.pk-logo {
  position absolute
  top -15px
  left 50%
  transform translateX(150%) skewX(-10deg)
  white-space nowrap
  text-align center
  background white
  padding 0 10px 0 20px
  font-size 20px
  font-weight bold
  box-shadow 0 1px 0 3px $dark
  z-index 1
  opacity 0
  transition .3s ease-out
}

.pk-icon {
  position absolute
  left 0
  top 0
  opacity 0
  transition all .1s linear .6s

  &:first-child {
    transform rotate(30deg)
    transform-origin bottom right
  }

  &:last-child {
    transform rotate(-30deg)
    transform-origin bottom left
  }
}

.is-active {
  .pk-icon {
    opacity 1
    transform rotate(0) !important
  }

  .pk {
    &:before {
      opacity 1
    }
  }

  .school {
    transform translateX(0)
    height 100px
  }

  .pk-logo {
    opacity 1
    transform translateX(-50%) skewX(-10deg)
  }
}

.spoon {
  transform rotate(45deg)
}

.fork {
  transform rotate(-45deg)
}

.school-left {
  background linear-gradient(to right, white, $link 100%)
  background $link
  padding-right 4rem
  transform translateX(-100%)

  .flag {
    text-align right
  }
}

.school-right {
  padding-left 4rem
  background linear-gradient(to left, white, $danger 100%)
  background $danger
  transform translateX(100%)
}

.image {
  border-radius 5px
  opacity 1
  width 80px
  height 80px
  z-index 1
}

.flag {
  flex-grow 1
  font-weight bold
  font-size 20px
  text-overflow ellipsis
  overflow hidden
  white-space nowrap
  color white
}
</style>
